export class LoggedUserConfiguration{
    
    allowedForAreaScheduling: boolean = false;
    allowedToCreateStore: boolean = false;
    allowedToCreateProgrammableObjective: boolean = false;
    allowedToCancelStoreCheck: boolean = false;
    allowedToDeleteStoreCheck: boolean = false;
    allowedToEditDashBoard: boolean = false;
    hideGeoTravelTime: boolean = false;
    hideWorkingHours: boolean = false;
    forbidToCreateStoreCheck: boolean = false;
    forbidToCreateEvent: boolean = false;
    
    static FromJson(json: any): LoggedUserConfiguration {
        let c = new LoggedUserConfiguration();
        c.allowedForAreaScheduling = json.allowedForAreaScheduling,
        c.allowedToCreateStore = json.allowedToCreateStore,
        c.allowedToCreateProgrammableObjective = json.allowedToCreateProgrammableObjective,
        c.allowedToCancelStoreCheck = json.allowedToCancelStoreCheck,
        c.allowedToDeleteStoreCheck = json.allowedToDeleteStoreCheck,
        c.allowedToEditDashBoard = json.allowedToEditDashBoard,
        c.hideGeoTravelTime = json.hideGeoTravelTime,
        c.hideWorkingHours = json.hideWorkingHours,
        c.forbidToCreateStoreCheck = json.forbidToCreateStoreCheck,
        c.forbidToCreateEvent = json.forbidToCreateEvent
        return c;
    }
    
}
